import React from 'react'
import Footer from './Footer';
import ContactSection from './ContactSection';

const Hire = () =>{
  return (
    <>
   
   <div className="above-sp2">

<ContactSection />
</div>
<Footer />


    </>
  )
}

export default Hire
